export default __webpack_public_path__ + "static/media/image-chair-algo-lima-04-l-w@2x.e8629d49.webp";